import React, { Component } from 'react'
import ZodiacSelector from './ZodiacSelector';
import DailyInputFied from './DailyInputField';
import WeeklyInputView from './WeeklyInputView';
import MonthlyField from './MonthlyField';
import YearInputField from './YearInputField';
import {getData2} from '../../Api/Config'
import M from  'materialize-css/dist/js/materialize.min.js';
import HoroscopeBox from './HoroscopeTypeForms/HoroscopeBox';
import CirclePreloader from './CirclePreloader'; 

export class ViewHoroscope extends Component {

    state={
        type:0,
        zodiacId:'',
        labels:['Daily','Weekly','Monthly','Yearly'],
        // data:{key:[],value:[]},
        result:null,
        isLoading:false
    }

    


    handleChange=(e)=>{
        this.setState({[e.target.id]:e.target.value});
    }

    GET_DAILY_URL=()=>{
        const {date,zodiacId} = this.state
        return `daily/zodiac?date=${date}&zodiacId=${zodiacId}`;
    }

    GET_Weekly_URL=()=>{
        const {WeekDate,zodiacId} = this.state
        return `weekly/zodiac?date=${WeekDate}&zodiacId=${zodiacId}`;
    }

    GET_Yearly_URL=()=>{
        const {yearDate,zodiacId} = this.state
        return `yearly/zodiac?year=${yearDate}&zodiacId=${zodiacId}`;
    }

    GET_Monthly_URL=()=>{
        const {monthDate,zodiacId} = this.state
        var arr = monthDate.split("-");
        var year = arr[0];
        var months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
        var month = months[arr[1]-1];// month name 
        var month2 = month;
        var year2 = year;

        return `monthly/zodiac?month=${month2}&year=${year2}&zodiacId=${zodiacId}`;
    }

    GetCalenderInfo= ()=>{
        this.setState({isLoading:true});
        let endUrl = '';   
        switch (this.state.type) {
            case 0:
                endUrl=this.GET_DAILY_URL()
                break;
            case 1:   
                endUrl=this.GET_Weekly_URL()
                break;
            case 2:   
                endUrl=this.GET_Monthly_URL()
                break;
            case 3:   
                endUrl=this.GET_Yearly_URL()
                break;       
            default:
                break;
        }
        const myUrl= `https://api.nirmallabs.com/api/v1/calendar/horoscope/${endUrl}`
        getData2(myUrl).then((res)=>{
            this.setState({isLoading:false});
            if(res){
                this.setState({result:res});
            }else{
                this.setState({result:null});
                M.toast({html: "No data found..!"});
            }
            document.querySelector('#result').scrollIntoView({
                    behavior: 'smooth'
                });
        }).catch((err)=>{
            this.setState({isLoading:false});
            this.setState({result:null})
            M.toast({html: "No data found..!"});
            console.log(err)
        })
    }
    
    IsValid=()=>{
        let flag = true;
        const {zodiacId,type,date,WeekDate,monthDate,yearDate} = this.state;
        if(zodiacId===undefined || zodiacId==='0' || zodiacId===''){
            this.setState({zodiac_err:' * zodiac not selected..!'})
            flag=false
        }else{
            this.setState({zodiac_err:''})
        }
        if(type===0 && (date===undefined || date==='0' || date==='')){
            this.setState({date_err:'* select a date..!'})
            flag=false
        }else{
            this.setState({date_err:''})
        }
        if(type===1 && (WeekDate===undefined || WeekDate==='0' || WeekDate==='')){
            this.setState({date_err:'* select a date..!'})
            flag=false
        }else{
            this.setState({date_err:''})
        }
        if(type===2 && monthDate===undefined){
            this.setState({date_err:'* select a date..!'})
            flag=false
        }else{
            this.setState({date_err:''})
        }
        if(type===3 && (yearDate===undefined || yearDate==='0' || yearDate==='')){
            this.setState({date_err:'* select a date..!'})
            flag=false
        }else{
            this.setState({date_err:''})
        }
        return flag;
    }
   

    handleSubmit=(e)=>{
        e.preventDefault()
        if(this.IsValid()){
            this.GetCalenderInfo()
        }
        
    }

    render() {
        let {type,result} = this.state
        const myStyle = {visibility:result!==null?'visible':'hidden'}
        return (
            <div>
                <div className="row " style={{marginTop:20}}>
                <h5 className="black-text">{this.state.labels[type]} Horoscope</h5>
                   <form className="card " onSubmit={this.handleSubmit}>
                   <div className="card-panel blue-grey white-text">Search Horoscope</div>
                       <div className="card-content">
                        <div className="row">
                            <div className="input-field col s12">
                              <ZodiacSelector handleChange={this.handleChange} />
                              <div style={{fontSize:12 ,color:"red"}}>{this.state.zodiac_err}</div>
                            </div>
                        </div>
                        <div className="row">
                        <div className="input-field col s6">
                                <select id="type" defaultValue="0" onChange={(e)=>this.setState({'type':parseInt(e.target.value)})}>
                                <option value="-1" disabled>Choose date type....</option>
                                <option value='0' >Daily</option>
                                <option value="1" >Weekly</option>
                                <option value="2" >Monthly</option>
                                <option value="3" >Yearly</option>
                                </select>
                            </div>
                         {type===0 && <DailyInputFied handleChange={this.handleChange} />}
                          {type===1 && <WeeklyInputView handleChange={this.handleChange}/>}
                          {type===2 && <MonthlyField handleChange={this.handleChange}/>}
                          {type===3 && <YearInputField handleChange={this.handleChange}/>}

                        </div>
                        <div style={{fontSize:12 ,color:"red"}}>{this.state.date_err}</div>

                        <button className="btn btn-small waves-effect waves-light blue-grey " style={{display:'block',margin:'auto'}} type="submit" name="action">View
                                <i className="material-icons right">pageview</i>
                            </button>
                       </div>
                   </form>
                </div>
                {/* show info */}
                {this.state.isLoading?<CirclePreloader/>:null}
                <div className="row" id="result" style={myStyle}>
                    <div className="card col s12">
                            <div className="card-content" >
                            <React.Fragment>
                               {this.state.result!==null?(
                                            <div>
                                            <HoroscopeBox title={'Zodiac english name'} data={result.zodiac.zodiacEnglishName} />
                                            <HoroscopeBox title={'Zodiac hindi name'} data={result.zodiac.zodiacHindiName} />
                                            <HoroscopeBox title={'Auspicious work'} data={result.zodiac.zodiacHindiName} />
                                            <HoroscopeBox title={'Business'} data={result.business} />
                                            <HoroscopeBox title={'Character Quality'} data={result.characterQuality} />
                                            <HoroscopeBox title={'Date'} data={result.date} />
                                            <HoroscopeBox title={'Health'} data={result.health} />
                                            <HoroscopeBox title={'Summary'} data={result.summary} />
                                            <HoroscopeBox title={'Travel'} data={result.travel} />
                                            <HoroscopeBox title={'Family & relation'} data={result.familyAndRelation} />
                                            <HoroscopeBox title={'Career'} data={result.career} />
                                            <HoroscopeBox title={'Love Relation'} data={result.loveRelation} />
                                            <HoroscopeBox title={'Vehicle Expenditure'} data={result.vehicleExpenditure} />
                                            <HoroscopeBox title={'Loss'} data={result.loss} />
                                            <HoroscopeBox title={'Loan'} data={result.loan} />
                                            <HoroscopeBox title={'Untoward'} data={result.untoward} />
                                            <HoroscopeBox title={'Remedy'} data={result.remedy} />
                                            <HoroscopeBox title={'Lucky Day'} data={result.luckyDay} />
                                            <HoroscopeBox title={'Lucky Gem'} data={result.luckyGem} />
                                            <HoroscopeBox title={'Married Life'} data={result.marriageAndMarriedLife} />
                                            <HoroscopeBox title={'Hobbies'} data={result.hobbies} />
                                            </div>
                               ):<h5>No data found...!</h5>}
                                 </React.Fragment>
                            </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViewHoroscope
